import React, { useState } from "react";
import { IAppState } from "redux/reducers";
import { connect } from "react-redux";
import { accountService } from "api/services/account-service";
import { AccountType, accountTypeDict, AuthenticationMode, ssoProviderDictionary } from "api/entities/account";
import { MicrosoftAuthButton, MicrosoftIcon } from "components/account-actions/external-auth/buttons/microsoft-auth-button";
import { SettingsTab } from "components/shared-ui/tabs/tabs";
import Button from "components/shared-ui/button";
import { useApi } from "utils/hooks/use-api";
import { ChangeSetPasswordPanel } from "./panels/change-set-password-panel";
import styles from "./account-tab.module.scss";

const mapStateToProps = (state: IAppState) => ({
    user: state.users.currentUser,
    loginFailed: state.account.loginFailed,
    loginError: state.account.loginError,
});

interface IAccountTabProps
    extends ReturnType<typeof mapStateToProps> {

    activeTab: SettingsTab;
}

export const AccountTab = connect(mapStateToProps, null)((props: IAccountTabProps) => {
    const [api] = useApi();
    const [authenticationMode, setAuthenticationMode] = useState<AuthenticationMode>(props.user.authenticationMode);
    const [hasExternalAccount, setHasExternalAccount] = useState<boolean>(!!props.user.externalAccount);
    const [changeSetPasswordPanelOpen, setChangeSetPasswordPanelOpen] = useState<boolean>(false);

    function getExternalAccountSection() {
        return <section>
            <div className={styles.row}>
                <div>SSO:</div>
                <div>
                    {!hasExternalAccount
                        ? "None"
                        : ssoProviderDictionary[props.user.externalAccount.ssoProvider]
                    }
                </div>
            </div>

            <div className={styles["column-button"]}>
            {!hasExternalAccount
                ?
                <MicrosoftAuthButton
                    redirectUri={window.location.href}
                    buttonText={"Attach Microsoft Account"}
                />
                :
                <Button
                    colors="primary"
                    onClick={() => {
                        api(accountService.detachExternalAccount())
                            .then(() => setHasExternalAccount(false));
                    }}
                    testId="button-sign-up">

                    <MicrosoftIcon/>
                    Detach Account
                </Button>
            }
            </div>
        </section>;
    }

    const changeSetPasswordButtonText = authenticationMode === AuthenticationMode.SSOOnly
        ? "Set Password"
        : "Change Password";

    return (
        <>
            <section>
                <div className={styles.row}>
                    <div>Name:</div>
                    <div>{props.user.name}</div>
                </div>

                <div className={styles.row}>
                    <div>Email:</div>
                    <div>{props.user.email}</div>
                </div>

                <div className={styles.row}>
                    <div>Type:</div>
                    <div>{accountTypeDict[props.user.accountType]}</div>
                </div>

                {authenticationMode === AuthenticationMode.SSOOnly
                    &&
                    <div className={styles["authentication-mode-desc"]}>
                        Your account is directly logged in from Single-Sign On
                    </div>
                }

                <div className={styles["column-button"]}>
                    <Button
                        colors="primary"
                        onClick={() => setChangeSetPasswordPanelOpen(true)}
                        testId="button-sign-up">

                        {changeSetPasswordButtonText}

                    </Button>
                </div>

                {props.user.accountType === AccountType.Enterprise
                    &&
                    <div className={styles.row}>
                        <div>Organization Name</div>
                        <div>{props.user.organization}</div>
                    </div>
                }

            </section>

            {getExternalAccountSection()}

            <ChangeSetPasswordPanel
                open={changeSetPasswordPanelOpen}
                onClose={(newAuthenticationMode: AuthenticationMode) => {
                    setChangeSetPasswordPanelOpen(false);
                    setAuthenticationMode(newAuthenticationMode);
                }}
            />
        </>
    );
});
